import { useState, useEffect } from "react";
import SimpleButton from '../common/SimpleButton';
import closeImg from "../../assets/images/btn_close.webp"
import imgHero from "../../assets/images/presale_hero.webp"
import imgBtn from "../../assets/images/btn_red.webp"
import imgBtnWithBlure from "../../assets/images/btn_red_with_blure.webp"
import imgBtnBlure from "../../assets/images/btn_red_blure.webp"
import s from './ModalPreSale.module.css'
import telegramWebAppAPI from "../../services/telegram";

interface ModalPreSaleProps {
    closeModal: () => void;
}

const ModalPreSale: React.FC<ModalPreSaleProps> = ({ closeModal }) => {
    const [isBlocked, setIsBlocked] = useState(true);
    const [timeLeft, setTimeLeft] = useState(7);

    useEffect(() => {
        let animationFrame: number;
        const startTime = performance.now();

        const tick = (currentTime: number) => {
            const elapsedTime = (currentTime - startTime) / 1000;
            const remainingTime = Math.max(7 - elapsedTime, 0);

            setTimeLeft(remainingTime);
            if (remainingTime > 0) {
                animationFrame = requestAnimationFrame(tick);
            } else {
                setIsBlocked(false);
            }
        };

        animationFrame = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(animationFrame);
    }, []);

    const circleRadius = 24;
    const circleCircumference = 2 * Math.PI * circleRadius;
    const strokeDashoffset = circleCircumference - (circleCircumference * (7 - timeLeft)) / 7;

    return (
        <div className={s.containerWrapper}>
            <div className={s.timerContainer}>
                {isBlocked ?
                    (<>
                        <svg className={s.timerCircle} width="60" height="60">
                            <circle
                                cx="30"
                                cy="30"
                                r={circleRadius}
                                fill="none"
                                stroke="var(--yellow-02)"
                                strokeWidth="4"
                                strokeDasharray={circleCircumference}
                                strokeDashoffset={strokeDashoffset}
                            />
                        </svg>
                        {timeLeft && <p className={s.timerText}>{Math.round(timeLeft)}</p>}
                    </>)
                    :
                    <SimpleButton imageUrl={closeImg} width={12} onClick={closeModal} />
                }
            </div>

            <div className={s.container}>
                <img className={s.imgHero} src={imgHero} alt="hero" />
                <p className={s.text}>BUY $MOO NOW BEFORE THE PRICE BLAST OFF!</p>

                <div className={s.buttonBlurePosition}>
                    <img className={s.imgBtnBlure} src={imgBtnBlure} alt="blure" />
                    <div className={s.buttonPosition}>
                        <SimpleButton className={s.button} onClick={() => { telegramWebAppAPI.openLink("https://moo.army") }} imageUrl={imgBtn}>
                            <p className={s.buttonText}>join pre-sale</p>
                        </SimpleButton>
                    </div>
                </div>
            </div>

            <div className={s.runningTextBox}>
                <div className={s.marquee}>
                    <p className={s.runningText}>
                        UNLOCK <span className={s.spanColor}>X100</span> MORE POTENTIAL!
                        UNLOCK <span className={s.spanColor}>X100</span> MORE POTENTIAL!
                        UNLOCK <span className={s.spanColor}>X100</span> MORE POTENTIAL!
                    </p>
                    <span className={s.space}>&nbsp;</span>
                    <p className={s.runningText}>
                        UNLOCK <span className={s.spanColor}>X100</span> MORE POTENTIAL!
                        UNLOCK <span className={s.spanColor}>X100</span> MORE POTENTIAL!
                        UNLOCK <span className={s.spanColor}>X100</span> MORE POTENTIAL!
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ModalPreSale